import { useSettleWindowRefetch } from "./useSettleWindowRefetch";

interface UseMinervaSettleRefetchOptions {
  /**
   * The Minerva flag (`isMinervaKbEnabled`). When false the returned handler is
   * a no-op — no settle timer is armed — so the flag-off (Atlas) flow is a true
   * rollback.
   */
  enabled: boolean;
}

/**
 * Minerva-gated settle-window refetch shared by both Answers chat surfaces —
 * the full page (`Chatbot`) and the sidebar (`AnswersChatContent`). Wraps
 * {@link useSettleWindowRefetch} so both consumers arm exactly one post-turn
 * refetch ~2s after the AGENT turn stops streaming, gated behind the Minerva
 * flag, without re-implementing that wiring in each place.
 *
 * Each consumer passes its own `refetch`, because the two surfaces reconcile
 * differently: the full page re-runs its `GetConversationDetails` query (whose
 * result flows through the details effect), while the sidebar triggers the lazy
 * query and merges the result into local state. Only the shared settle/gating
 * plumbing lives here; the arming call site (on AGENT messages) stays in each
 * consumer.
 */
export const useMinervaSettleRefetch = (
  refetch: () => void,
  { enabled }: UseMinervaSettleRefetchOptions,
): (() => void) => useSettleWindowRefetch(refetch, { enabled });
